import React from 'react';
import PropTypes from 'prop-types';
import TagManager from 'react-gtm-module';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';
import {
  Wrapper,
  Title,
  Text,
  LinkButton,
  FidelizeLogo,
  SolidShape,
  CombinedShape,
  CurvedShape
} from './styles';
import combinedShape from '../../../../../assets/images/combinedShape.svg';
import solidShape from '../../../../../assets/images/solidShape.svg';
import curvedShape from '../../../../../assets/images/curvedShape.svg';

const FidelizeBanner = ({
  bannerTitle,
  bannerText,
  bannerButtonText,
  redirectButtonVisible
}) => {
  const handleButtonClick = () => {
    const { externalId, userId } = JSON.parse(
      window.localStorage.getItem('broker')
    );
    TagManager.dataLayer({
      dataLayer: {
        event: 'ClickFidelizeBannerButton',
        userId,
        brokerId: externalId
      }
    });
    window.open(getSessionItem('PLATAFORMA_FIDELIZE'), '_blank');
  };

  return (
    <Wrapper>
      <div>
        <FidelizeLogo
          src="https://static.juntoseguros.com/images/logo-fidelize.png"
          data-testid="banner-fidelize-logo"
          alt="Logo - Fidelize"
        />
      </div>
      <div>
        <Title>{bannerTitle}</Title>
        <Text>{bannerText}</Text>
        {redirectButtonVisible && (
          <LinkButton type="button" onClick={() => handleButtonClick()}>
            {bannerButtonText}
          </LinkButton>
        )}
      </div>
      <div>
        <SolidShape src={solidShape} />
        <CombinedShape src={combinedShape} />
        <CurvedShape src={curvedShape} />
      </div>
    </Wrapper>
  );
};

FidelizeBanner.propTypes = {
  bannerTitle: PropTypes.string.isRequired,
  bannerText: PropTypes.string.isRequired,
  bannerButtonText: PropTypes.string.isRequired,
  redirectButtonVisible: PropTypes.bool.isRequired
};

export default FidelizeBanner;
